<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container class="registration">
    <v-app-bar app flat height="79px">
      <a class="logo d-none d-sm-flex ma-sm-3">
        <v-img
          class="logo d-none d-sm-flex ma-sm-3"
          src="../assets/logo-plus.png"
          width="60px"
        ></v-img>
      </a>
      <v-spacer></v-spacer>
      <!-- переключатель языка -->
      <the-language-switcher />
    </v-app-bar>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            {{ $t("registration.complete_your_userinfo") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="userName"
                    :label="$t('registration.username') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesUserNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="password"
                    :label="$t('registration.code') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesCodeField"
                    counter
                    maxlength="4"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    @keypress="onlyNumber"
                    @input="onCodeInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    :label="$t('registration.first_name') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesFirstNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="surname"
                    :label="$t('registration.last_name') + '*'"
                    required
                    outlined
                    clearable
                    :error-messages="errorMessagesLastNameField"
                    counter
                    maxlength="20"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="saveUser">
              {{ $t("registration.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-card-title>
            {{ $t("registration.your_userinfo") }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.email_address")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.email }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.country_code")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationCountryCode }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.postal_code")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationPostalCode }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.place")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationPlace }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-card>
                  <v-card-subtitle>{{
                    $t("registration.street")
                  }}</v-card-subtitle>
                  <v-divider></v-divider>
                  <v-card-text>{{ user.operationStreet }}</v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-footer id="nav" color="#fff">
      <v-container>
        <div class="d-flex align-center justify-space-between footer-box">
          <a class="logo">
            <v-img src="../assets/logo-plus.png" width="60px"></v-img>
          </a>

          <!-- <div class="d-flex align-center footer-menu">
                        <router-link :to="{name:'help'}">{{ $t('help') }}</router-link>
                        <router-link :to="{name:'faq'}">{{ $t('faq') }}</router-link>
                        <router-link :to="{name:'about'}">{{ $t('about') }}</router-link>
                    </div> -->

          <v-spacer></v-spacer>

          <div class="copyright-footer">
            &copy;
            {{ $t("copyright", { currentYear: this.$store.state.currentYear })
            }}<span>|</span>
            <router-link :to="{ name: 'help' }">{{
              $t("disclaimer")
            }}</router-link
            ><span>|</span>
            <router-link :to="{ name: 'help' }">{{
              $t("privacy_policy")
            }}</router-link>
          </div>
        </div>
      </v-container>
    </v-footer>
    <v-snackbar v-model="snackbar.show" bottom :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          CLOSE
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import config from "../config";
import Axios from "axios";
import router from "@/router";
import { i18n } from "@/plugins/i18n";
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher.vue";
const qs = require("querystring");

export default {
  name: "Registration",
  components: {
    TheLanguageSwitcher,
  },
  data() {
    return {
      paramStr: "",
      errorMessagesUserNameField: "",
      errorMessagesCodeField: "",
      errorMessagesFirstNameField: "",
      errorMessagesLastNameField: "",
      user: {},

      snackbar: {
        show: false,
        text: "",
        timeout: 4000,
      },
    };
  },
  created() {
    let $this = this;
    this.paramStr = this.$route.params.id;

    Axios.get(
      config.apiBaseUrl +
        "api/employee/signing-user?EncryptGuid=" +
        this.paramStr,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    )
      .then(function(response) {
        if (response.status === 200) {
          const data = response.data || {};
          // normalization of required fields
          $this.user = {
            ...data,
            userName: data.userName || "",
            password: data.password || "",
            name: data.name || "",
            surname: data.surname || "",
          };
        }
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  },
  computed: {
    userName: {
      get() {
        return this.user.userName;
      },
      set(v) {
        this.user.userName = v;
      },
    },
    password: {
      get() {
        return this.user.password;
      },
      set(v) {
        this.user.password = v;
      },
    },
    name: {
      get() {
        return this.user.name;
      },
      set(v) {
        this.user.name = v;
      },
    },
    surname: {
      get() {
        return this.user.surname;
      },
      set(v) {
        this.user.surname = v;
      },
    },
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode === 46 || keyCode === 192) {
        // 46 is dot
        this.errorMessagesCodeField = this.$i18n.t("enterOnlyNumbers");
        $event.preventDefault();
      }
    },

    onCodeInput(v) {
      const cleaned = String(v || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      if (cleaned !== this.user.password) {
        this.user.password = cleaned;
      }
    },

    saveUser(e) {
      e.preventDefault();

      this.errorMessagesUserNameField = "";
      this.errorMessagesCodeField = "";
      this.errorMessagesFirstNameField = "";
      this.errorMessagesLastNameField = "";

      let errorsCount = 0;

      const user = this.user || {};

      if (!user.userName || user.userName.trim().length === 0) {
        this.errorMessagesUserNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (!/^\d{4}$/.test(String(user.password || ""))) {
        this.errorMessagesCodeField = this.$i18n.t("error_check_code_length");
        errorsCount++;
      }

      if (!user.name || user.name.trim().length === 0) {
        this.errorMessagesFirstNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (!user.surname || user.surname.trim().length === 0) {
        this.errorMessagesLastNameField = this.$i18n.t("field_is_required");
        errorsCount++;
      }

      if (errorsCount !== 0) return;

      Axios.post(
        config.apiBaseUrl + "api/employee/edit-signing-user",
        qs.stringify(user),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
      )
        .then((response) => {
          if (response.status === 200) {
            this.snackbar.text = "The form has been saved successfully";
            this.snackbar.show = true;

            setTimeout(() => {
              let redirectPath = "/" + i18n.locale;
              router.push(redirectPath);
            }, 600);
          }
        })
        .catch((error) => {
          alert(error.response.data);
        });
    },
  },
  watch: {
    userName() {
      this.errorMessagesUserNameField = "";
    },
    password() {
      this.errorMessagesCodeField = "";
    },
    name() {
      this.errorMessagesFirstNameField = "";
    },
    surname() {
      this.errorMessagesLastNameField = "";
    },
  },
};
</script>
